import { useTranslation } from 'react-i18next';

import { useViewerContext, ViewerMode } from '@/features/document-viewer/use-viewer-context';
import { useFileTreeContext } from '@/pages/insight/folders/use-file-tree-context';
import { TreeFolder } from '@/pages/insight/folders/util/document-list-to-tree';

import { Category } from './category';

export const AllDocuments = () => {
  const { t } = useTranslation();
  const { setMode } = useViewerContext();
  const { setSelectedCard } = useFileTreeContext();
  const { setActiveFolderId, activeFolderId } = useFileTreeContext();

  const handleClick = () => {
    setActiveFolderId('');
    setMode(ViewerMode.Closed);
    setSelectedCard('');
  };

  // Create a mock TreeEntry for the "All Documents" category
  const allDocumentsEntry: TreeFolder = {
    id: '__all_documents__',
    level: 0,
    toDisplayString: () => t('folders.all-documents'),
    children: new Map(),
  };

  return (
    <Category
      title={t('folders.all-documents')}
      entry={allDocumentsEntry}
      mode="clickable"
      showDocumentCount={true}
      onCustomClick={handleClick}
      className={!activeFolderId ? 'bg-day-light-3' : ''}
    />
  );
};
